<mat-dialog-content>
  <webcam class="webcam-display" [trigger]="trigger.asObservable()" (imageCapture)="onImageCapture($event)"></webcam>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button class="issue-btn-left dialog-btn-left" color="primary" mat-dialog-close><mat-icon>clear</mat-icon> {{'cancel' | translate}}</button>
  <button mat-raised-button class="dialog-btn-right" color="primary" (click)="trigger.next()"><mat-icon>check</mat-icon> {{'save' | translate}}</button>
</mat-dialog-actions>
